import { defineComponent as _defineComponent } from 'vue'
import { computed, useAsync, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useLinkService, useTranslate } from "@/composables";
import { getLtksStore } from "@/store/ltks";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkPost',
  props: {
  postId: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const AVATAR_SIZE = "32";



const store = useStore();
const route = useRoute();
const { t } = useTranslate();
const amplitude = useAmplitude();
const linkService = useLinkService();
const ltksStore = getLtksStore(store);

const post = computed(() => ltksStore.ltks[props.postId]);
const profile = computed(() => getProfilesStore(store)?.getProfileById(post.value?.profileId));
const displayName = computed(() => profile.value?.displayName ?? t("My Shop").value);
const avatarUrl = computed(() =>
  profile.value?.avatarUrl === undefined
    ? ""
    : linkService.getImageLink({
        url: profile.value?.avatarUrl,
        width: AVATAR_SIZE,
        height: AVATAR_SIZE,
      }),
);

const hasVideo = computed(() => Boolean(post.value?.videoMediaId));
const hasProducts = computed(() => Boolean((post.value?.productIds?.length ?? 0) > 0));

const shareTitle = t("{displayName}'s Post on LTK", { displayName: displayName.value });
const shareText = t("Shop the products featured in this Post from {displayName}", { displayName: displayName.value });
const noProductsText = t("No tagged products");
const avatarAltText = t("{influencerName} on LTK", { influencerName: displayName.value });

const referringComponent = computed(() => amplitude?.getReferringComponentByPage(route.value.name ?? "") ?? "");

useAsync(async () => {
  !post.value && (await getLtksStore(store).fetchLtkByIdAggregate({ id: props.postId }));
  !profile.value && post.value?.profileId && (await getProfilesStore(store).fetchProfileById(post.value.profileId));
});

return { __sfc: true,AVATAR_SIZE, props, store, route, t, amplitude, linkService, ltksStore, post, profile, displayName, avatarUrl, hasVideo, hasProducts, shareTitle, shareText, noProductsText, avatarAltText, referringComponent }
}

})